var _regeneratorRuntime = require("C:\\Users\\theba\\Documents\\DEVL\\DevilPortalV2\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\theba\\Documents\\DEVL\\DevilPortalV2\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _classCallCheck = require("C:\\Users\\theba\\Documents\\DEVL\\DevilPortalV2\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\theba\\Documents\\DEVL\\DevilPortalV2\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\theba\\Documents\\DEVL\\DevilPortalV2\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _get = require("C:\\Users\\theba\\Documents\\DEVL\\DevilPortalV2\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/get");

var _getPrototypeOf = require("C:\\Users\\theba\\Documents\\DEVL\\DevilPortalV2\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\theba\\Documents\\DEVL\\DevilPortalV2\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var BaseFilter = require('./base-filter'); // tracks all results ever recorded


var BaseFilterWithHistory = /*#__PURE__*/function (_BaseFilter) {
  "use strict";

  _inherits(BaseFilterWithHistory, _BaseFilter);

  function BaseFilterWithHistory() {
    var _this;

    _classCallCheck(this, BaseFilterWithHistory);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaseFilterWithHistory).call(this));
    _this.allResults = [];
    return _this;
  }

  _createClass(BaseFilterWithHistory, [{
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                throw new Error('BaseFilterWithHistory - no update method specified');

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function update() {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "addResults",
    value: function addResults(newResults) {
      this.allResults = this.allResults.concat(newResults);

      _get(_getPrototypeOf(BaseFilterWithHistory.prototype), "addResults", this).call(this, newResults);
    }
  }, {
    key: "addInitialResults",
    value: function addInitialResults(newResults) {
      this.allResults = this.allResults.concat(newResults);

      _get(_getPrototypeOf(BaseFilterWithHistory.prototype), "addInitialResults", this).call(this, newResults);
    }
  }, {
    key: "getAllResults",
    value: function getAllResults() {
      return this.allResults;
    }
  }]);

  return BaseFilterWithHistory;
}(BaseFilter);

module.exports = BaseFilterWithHistory;